export { default as default } from '../modules/unicode'


//////////////////
// WEBPACK FOOTER
// ./node_modules/country-flag-icons/unicode/index.js
// module id = 1684
// module chunks = 1